// Built as nodes rather than as a string, so an author's name can only ever be text.
export const mentionOf = (name: string, email: string): string => {
  const mention = document.createElement('span');
  mention.className = 'mention';
  mention.dataset.index = '1';
  mention.dataset.denotationChar = '@';
  mention.dataset.id = email;
  mention.dataset.value = name;
  mention.setAttribute('contenteditable', 'false');
  mention.textContent = `@${name}`;
  const paragraph = document.createElement('p');
  paragraph.append(mention, '\u00a0');
  return paragraph.outerHTML;
};
